import React from 'react'

import { ListGroup } from 'reactstrap'
import { observer } from 'mobx-react'

import cx from 'classnames'

import Card from 'common/Card'
import PendingActionItem from './PendingActionItem'

export default observer(
  ({
    groupName,
    pendingActions,
    session,
    resource,
    actions,
    headerClassName,
    cardBodyToggleButtonClassName,
    cardBodyToggleIconClassName,
  }) => {
    return (
      <div id={groupName} className="mb-2">
        <Card
          titleClassName={cx(headerClassName, 'white-space-nowrap flex-lg-row flex-column')}
          actions={actions}
          defaultIsBodyOpen
          cardBodyCollapse
          cardBodyToggleButtonClassName={cardBodyToggleButtonClassName}
          cardBodyToggleIconClassName={cardBodyToggleIconClassName}
          title={
            <div className="mb-lg-0 mb-1 white-space-break-spaces text-lg-start text-center">
              <strong>{groupName}</strong>
            </div>
          }
        >
          <ListGroup className="cases-list list-hover">
            {pendingActions.map((pendingAction, index) => {
              return (
                <PendingActionItem key={index} pendingAction={pendingAction} session={session} resource={resource} />
              )
            })}
          </ListGroup>
        </Card>
      </div>
    )
  }
)
